// 首屏 boot 载荷（纯函数，constantFunction.js 的 DOM / fetch 胶水之外的部分，node:test 可测）
//
// 服务端（apps/server/src/routes/public-html.ts 的 buildBoot）在返回 index.html 时把「URL 里的卡」的目录项 + 正文、
// 它们的反链目录项、站点设置一起塞进 <script id="notes-boot" type="application/json">。
// 前端凭它不等 /v1/index 就能渲染当前卡：有目录缓存的把这几张新鲜目录项合并进旧缓存；没缓存的先用只有这几张的「部分目录」。

/**
 * 解析 boot JSON 文本。形状不对 / 不是本站（basename 与注入时的 URL 不一致）→ null
 * @returns {{ username: string, site: object, cards: Array<object> } | null}
 */
export function parseBoot(text, tenant) {
    if (!text || !tenant) return null
    let boot
    try {
        boot = JSON.parse(text)
    } catch (error) {
        return null
    }
    if (!boot || boot.username !== tenant || !Array.isArray(boot.cards)) return null
    const cards = boot.cards.filter((c) => c && typeof c.id === 'string' && typeof c.title === 'string')
    if (!cards.length) return null
    return { username: boot.username, site: boot.site && typeof boot.site === 'object' ? boot.site : {}, cards: cards }
}

/** 只有 boot 那几张卡的「部分目录」，形状与 /v1/index 一致（目录项浅拷贝：后续渲染会往上面挂 DOM / 时间差） */
export function bootIndex(boot) {
    return { code: 0, data: { cards: boot.cards.map((c) => ({ ...c })) }, site: boot.site }
}

/**
 * 把 boot 的新鲜目录项合并进缓存的旧目录：同 id 的整项替换（标题 / contentHash / coverKey / 反链都以服务端刚给的为准），
 * 没有的插到最前（handleHeptabaseData 之后会按 lastEditedTime 重排）；site 用 boot 的。返回新 payload，不动入参
 */
export function mergeBootIntoIndex(payload, boot) {
    if (!boot) return payload
    const fresh = new Map(boot.cards.map((c) => [c.id, { ...c }]))
    const cards = []
    for (const card of payload.data.cards) {
        const f = fresh.get(card.id)
        if (f) {
            cards.push(f)
            fresh.delete(card.id)
        } else {
            cards.push(card)
        }
    }
    return { ...payload, data: { ...payload.data, cards: [...fresh.values(), ...cards] }, site: boot.site }
}
